import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "./locales/en/translation.json"; // This file contains all text in English
import translationFA from "./locales/fa/translation.json"; // This file contains all text in Farsi

// Initializing this library with options
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: translationEN,
    },
    fa: {
      translation: translationFA,
    },
  },
  lng: window.localStorage.getItem("language") || "en", // Selected language: At first selects language from local storage(default is English)
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
